import BaseRoute from "utils/base_route";
import requestor from "requestor";
import getRouteIds from "utils/get_route_ids";

import MatterListContainer from "./containers/matter_list";

import fetchProjectAction from "modules/projects/actions/project_fetch";
import fetchMattersAction from "modules/matters/actions/fetch";
import clearMattersAction from "modules/matters/actions/clear";

export default class MatterList extends BaseRoute {
  constructor(store, path) {
    super(path, store);
  }

  getComponents(location, cb) {
    cb(null, MatterListContainer);
  }

  onEnter(nextState, replace, callback) {
    (async () => {
      const {organisationId, projectId} = nextState.params;

      await this.ensureProjectLoaded(
        fetchProjectAction(requestor),
        organisationId,
        projectId,
      );

      if (this.shouldRedirectToDocuments()) {
        replace(this.getDocumentsRedirectPath(nextState));
        return callback();
      }

      super.onEnter(nextState, replace, callback);
    })();
  }

  shouldRedirectToDocuments() {
    const state = this.store.getState();
    const project = state.project;

    return project?.top_level_items === "document";
  }

  getDocumentsRedirectPath(state) {
    return state.location.pathname.replace(/matter/, "document");
  }

  fetchActiveData(state) {
    this.fetchMatters(state);
  }

  fetchMatters(state) {
    const {organisationId, projectId} = getRouteIds(state.router);
    this.store.dispatch(
      fetchMattersAction(requestor)(organisationId, projectId),
    );
  }

  clearActiveData() {
    const {dispatch} = this.store;
    dispatch(clearMattersAction());
  }
}
